import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'fuse-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
})
export class FuseConfirmDialogComponent {
    public confirmMessage = '';
    public confirmMessageTranslation = '';
    public paragraph = [];
    public rows: string[] = [];
    public blueItalicLine = '';
    public title?: string;
    public yesLabel?: string;
    public noLabel?: string;
    public noTitle = false;
    public inputLabel = '';
    public noCancel = false;
    public rowFontSize = 14;
    input = '';

    constructor(public dialogRef: MatDialogRef<FuseConfirmDialogComponent>) {}

    getReturnValue() {
        return this.inputLabel.length
            ? { result: true, input: this.input }
            : true;
    }
}
